import { Divider, Collapse, Progress } from 'antd'
import styled from 'styled-components'

const { Panel } = Collapse

const FlexBox = styled.div`
    display: flex; 
    justify-content: space-around;

    @media only screen and (max-width: 768px) {
        display: block;
        text-align: center;
    }
`


export default function Skills() {
    return <>

        <Collapse bordered={false} defaultActiveKey={['language']} accordion>
            <Panel header='Languages' key='language'>
                <FlexBox>
                    <span>
                        <h2>🇹🇭 THAI</h2>
                        <Progress type="circle" width={136} percent={100} format={() => 'Native'} />
                    </span>
                    <span>
                        <h2>🇬🇧 ENGLISH</h2>
                        <Progress className='twoline-progess' type="circle" width={136} percent={77} format={() => <span style={{ fontSize: 14 }}>Working<br />Proficiency</span >} />
                        <br /><br />
                        <h4>TOEIC</h4>
                        <strong>Overall: 975</strong><br />
                        <em>LC: 490, RC: 485</em>
                    </span>
                    <span>
                        <h2>🇰🇷 KOREAN</h2>
                        <Progress className='twoline-progess' type="circle" width={136} percent={(200 / 300) * 100} format={() => <span style={{ fontSize: 14 }}>Upper <br /> Intermediate</span >} />
                        <br /><br />
                        <h4>TOPIK / TOPIK IBT / TOPIK Speaking </h4>
                        <strong>등급: 5급 / 6급 / 3급</strong><br />
                        <em>듣기: 96 - 읽기: 74 - 쓰기: 56 / 듣기: 173 - 읽기: 164 - 쓰기: 124 / 말하기: 109</em>
                    </span>
                </FlexBox>
            </Panel>
            <Panel header='Technical Skills' key='hard'>
                <h2>KEY SKILLS</h2>
                <p>Web and Mobile Application Development, User Interface Design, Application Programming Interface (API) Development &amp; Design, Database Design, Data Mining, Machine Learning, Deep Learning</p>
                <h2>PROGRAMMING &amp; DEVELOPING</h2>
                <FlexBox>
                    <span>
                        <Progress style={{ width: 140 }} size='small' percent={100} format={() => 'Experienced'} />
                        <h3>Programming Languages</h3>
                        <p>HTML/CSS, Javascript, Python</p>
                        <h3>Frameworks and Libraries</h3>
                        <p> Node.js, Express.js, jQuery,<br /> Materialize, Ant Design, Bootstrap</p>
                        <h3>Cloud Services and Tools</h3>
                        <p>Firebase, Robo3T, Visual Studio Code</p>
                        <h3>CMS</h3>
                        <p>Wordpress</p>
                    </span>
                    <span>
                        <Progress size='small' style={{ width: 140 }} percent={55} status='active' format={() => 'Intermediate'} />
                        <h3>Programming Languages</h3>
                        <p>Java, PHP, Typescript, SQL, R</p>
                        <h3>Frameworks and Libraries</h3>
                        <p>React, React Native, Angular</p>
                        <h3>Cloud Services and Tools</h3>
                        <p>Amazon AWS</p>
                        <h3>Database</h3>
                        <p>MongoDB, MySQL</p>
                    </span>
                    <span>
                        <Progress size='small' style={{ width: 140 }} percent={25} status='exception' format={() => 'Beginner'} />
                        <h3>Programming Languages</h3>
                        <p>C#, Ruby, COBOL</p>
                        <h3>Frameworks and Libraries</h3>
                        <p>CakePHP, Laravel, Ruby on Rails, Vue.js, Tensorflow</p>
                        <h3>Cloud Services and Tools</h3>
                        <p>Google Cloud Platform, Heroku, Microsoft Azure</p>
                    </span>
                </FlexBox>
                <Divider>MASTERY IS NOT A COMMITMENT TO A GOAL BUT TO A CONSTANT PURSUIT</Divider>
                <h2>SOFTWARE & APPLICATION</h2>
                <FlexBox>
                    <span>
                        <Progress style={{ width: 140 }} size='small' percent={100} format={() => 'Expert'} />
                        <h3>Office</h3>
                        <p>MS Word, MS Excel, MS Powerpoint, Keynote, Pages</p>
                        <h3>Design</h3>
                        <p>Sketch, Adobe XD</p>
                    </span>
                    <span>
                        <Progress size='small' style={{ width: 140 }} percent={55} status='active' format={() => 'Intermediate'} />
                        <h3>Office</h3>
                        <p>Numbers</p>
                        <h3>Multimedia</h3>
                        <p>Final Cut Pro, iMovie, Photoshop, After Effects</p>
                    </span>
                    <span>
                        <Progress size='small' style={{ width: 140 }} percent={25} status='exception' format={() => 'Beginner'} />
                        <h3>Multimedia</h3>
                        <p>Illustrator, Premiere Pro, GarageBand</p>
                    </span>
                </FlexBox>
            </Panel>
            <Panel header='Soft Skills' key='soft'>
                <h2>KEY SKILLS</h2>
                <ul>
                    <li>Self-Motivation</li>
                    <li>Ready to Learn, Unlearn and Relearn</li>
                    <li>Positive attitude</li>
                    <li>Teamwork and Leadership</li>
                    <li>Time Management</li>
                    <li>Critical Thinking</li>
                    <li>Flexibility</li>
                    <li>Responsibility</li>
                    <li>Friendly Personality</li>
                    <li>Patience</li>
                    <li>Creativity</li>
                </ul>
            </Panel>
        </Collapse>

    </>
}